import React from "react";
import AllReleases from "../../components/all-releases/all-releases.js";
import useTitle from "../../hooks/useTitle.js";
import { isLoggedIn } from "../../utils/auth.js";
import { AUTH_SCREEN } from "../../utils/url.js";

export default function AllReleasesPage({ setPageTitle }) {
  useTitle("Admin");

  if (!isLoggedIn()) {
    window.location = '/';;
    return null;
  }

  return <AllReleases setPageTitle={setPageTitle}></AllReleases>;
}
